import { DataGrid, type GridColDef, type GridLocaleText, type GridRowParams } from "@mui/x-data-grid";
import { Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";



interface DataGridProps {
    columns: GridColDef[];
    rows: Array<any>;
    title?: string;
    getDetailPanelContent?: (params: GridRowParams) => React.ReactNode;
}

export default function CarSharingDataGrid({ columns, rows, title, getDetailPanelContent }: DataGridProps) {

    const { t } = useTranslation(['customerbase']);

    const customLocaleText: Partial<GridLocaleText> = {
        noRowsLabel: t('csDataGrid.noRowsLabel'),
        columnHeaderSortIconLabel: 'Ordina',
        MuiTablePagination: {
            labelRowsPerPage: 'Righe per pagina',
            labelDisplayedRows: ({ from, to, count }) => `${from}-${to} / ${count}`,
            nextIconButtonProps: {
                title: 'Avanti',

            },
            backIconButtonProps: {
                title: 'Indietro',
            }
        }
    }

    return (
        <>
            <Grid item sx={{ flex: 1, maxWidth: '100%' }}>
                {title && <Typography align={'left'} paddingLeft={1} paddingBottom={1}>{title}</Typography>}
                <DataGrid
                    columns={columns}
                    rows={rows}
                    rowHeight={60}
                    initialState={{
                        pagination: { pageSize: 5 },
                    }}
                    localeText={customLocaleText}
                    disableColumnFilter
                    disableColumnMenu
                    disableSelectionOnClick
                    autoHeight
                    getDetailPanelContent={getDetailPanelContent}
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: 'nowrap',
                            lineHeight: 'normal',
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-columnSeparator:last-child': {
                            width: '1px',
                        },
                        '& .MuiDataGrid-cell': {
                            whiteSpace: 'normal !important',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: 'rgba(0, 0, 0, 0.03)',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.10)',
                        },
                        '& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': {
                            visibility: 'hidden !important',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            position: 'unset !important',
                        },


                        '& .MuiDataGrid-overlay': {
                            minHeight: '120px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '1rem',
                            fontWeight: 500,

                        },
                    }}
                />
            </Grid>
        </>
    )
}
